import posthog from "posthog-js";
import { isLocalDev } from "@/lib/posthog";
import { takeSharedHostDistinctId } from "@/lib/posthogIdentityCookie";
import { User } from "../types";
import * as Sentry from "@sentry/react";
import { isImpersonating } from "./auth";

export const posthogIdentify = (user: User) => {
  if (!isLocalDev && !isImpersonating()) {
    try {
      const previousDistinctId = posthog.get_distinct_id();
      posthog.identify(user.uuid, {
        name: [user.first_name, user.last_name].filter(Boolean).join(" "),
        email: user.email,
        first_name: user.first_name,
        last_name: user.last_name,
        user_id: user.id,
        role: user.role_FK?.role_title,
        permissions: user.permission,
      });
      // Merge the anonymous person from the shared host (sign-up, CLI hand-off)
      // into this identified person. This load's own id is skipped: identify
      // has just merged it.
      const sharedHostDistinctId = takeSharedHostDistinctId();
      if (
        sharedHostDistinctId !== null &&
        sharedHostDistinctId !== user.uuid &&
        sharedHostDistinctId !== previousDistinctId
      ) {
        posthog.alias(sharedHostDistinctId);
      }
    } catch (error) {
      console.warn("Failed to identify user in PostHog:", error);
    }
  } else {
    try {
      takeSharedHostDistinctId();
    } catch (error) {
      console.warn("Failed to clear the shared-host PostHog id cookie:", error);
    }
  }
};

export const sentrySetUser = (user: User) => {
  try {
    Sentry.setUser({
      id: user.uuid,
      email: user.email,
      username: [user.first_name, user.last_name].filter(Boolean).join(" "),
      role: user.role_FK?.role_title,
      permissions: user.permission,
    });
  } catch (error) {
    console.warn("Failed to set user context in Sentry:", error);
  }
};

export const rollbarSetUser = (user: User) => {
  try {
    if (window.Rollbar) {
      window.Rollbar.configure({
        payload: {
          person: {
            id: user.uuid,
            email: user.email,
            username: [user.first_name, user.last_name].filter(Boolean).join(" "),
            role: user.role_FK?.role_title,
            permissions: user.permission,
          },
        },
      });
    }
  } catch (error) {
    console.warn("Failed to set user context in Rollbar:", error);
  }
};
